import React from "react";
import { Stars } from '@prosolve/common-components-ui'

export default ({
  feedbackData = {}
}) => {

  const { 
    counts = {},
    questions = []
  } = feedbackData;

  const starQuestion = questions.find(({ type }) => type === 'stars')

  let avgStarsDisplay = '-';
  let avgRankingPercent;
  let totalResponsesCount = '-';

  if (starQuestion) {
    const starQId = starQuestion.id;
    const maxStars = starQuestion.totalStars || 10;
    const starQCount = counts[starQId]

    if (starQCount) {
      let totalRankingSum = 0;
      totalResponsesCount = 0;

      Object.keys(starQCount).forEach(ranking => {
        const totalOfRanking = starQCount[ranking];
        totalResponsesCount += totalOfRanking;
        totalRankingSum += (totalOfRanking * ranking)
      });

      if (totalResponsesCount > 0) {
        avgRankingPercent = totalRankingSum / (totalResponsesCount * maxStars)
        avgStarsDisplay = Math.round( ( (avgRankingPercent * 10) / 2 ) * 10 ) / 10
      }
    }
  }

  return (
    <div style={{
      flex: 1,
      display: 'flex',
      columnGap: '20px',
      rowGap: '20px',
      padding: '20px',
      flexWrap: 'wrap',
      color: '#565656',
    }}>

      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start'
      }}>
        <div style={{
          fontSize: '18px',
          marginBottom: '10px',
          
        }}>
          {'Average Program Rating'}
        </div>
        <div style={{
          display: 'flex',
          alignItems: 'center',
        }}>
          <div style={{
            fontWeight: 'bold',
            fontSize: '24px',
            color: '#363636',
            marginRight: '10px'
          }}>
            {avgStarsDisplay}
          </div>
          {
            avgRankingPercent !== undefined &&
            <Stars stars={(avgRankingPercent * 10)} />
          }
        </div>
      </div>

      <div style={{
        borderRight: '1px solid #c4c4c4',
        marginRight: '1px'
      }}>
        &nbsp;
      </div>

      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start'
      }}>
        <div style={{
          fontSize: '18px',
          marginBottom: '10px'
        }}>
          {'Feedback Responses'}
        </div>
        <div style={{
          fontWeight: 'bold',
          fontSize: '24px',
          color: '#363636'
        }}>
          {totalResponsesCount}
        </div>
      </div>

    </div>
  )
}